import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { useCurrentLanguage, localize } from "@/hooks/useLanguage";

export default function ArticleSection() {
  const { t } = useTranslation();
  const lang = useCurrentLanguage();

  return (
    <section id="articles" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            {t("articles.title")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t("articles.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={localize(article.title, lang)}
                  title={`${localize(article.title, lang)} - USFans Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-800">
                  {t(`cat.${article.categoryKey}`)}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime} {t("articles.minRead")}
                  </span>
                  <span>{article.updated}</span>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors">
                  {localize(article.title, lang)}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {localize(article.excerpt, lang)}
                </p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-primary-600 whitespace-nowrap">
                  {t("articles.readMore")}
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}